export default "__VITE_ASSET__DFYPWEBA__"